module.exports = __webpack_public_path__ + "img/editicon.fd1e7fac.svg";